import React from 'react';
import {
  string,
  shape,
  oneOf,
  bool,
  func,
} from 'prop-types';
import { getImageUrl } from 'helpers/Utils';
import Link from 'components/common/Link';
import LazyLoadImg from 'components/common/LazyLoadImg';

const ProductImage = (props) => {
  const {
    to,
    alt,
    src,
    imageDimensions,
    className,
    orientation,
    lazy,
    onImageClick,
  } = props;

  const { width, height } = imageDimensions;

  const imgSrc = getImageUrl(src, { width: orientation === 'PORTRAIT' ? +height || '' : +width || '', height: orientation === 'PORTRAIT' ? +width || '' : +height || '' });

  return (
    <Link to={to} onClick={onImageClick}>
      <LazyLoadImg
        alt={alt}
        src={imgSrc || ''}
        className={className}
        style={{
          width: (orientation === 'PORTRAIT') ? +height || '' : +width || '',
          maxHeight: (orientation === 'PORTRAIT') ? +width || '' : +height || '',
        }}
        lazy={lazy}
      />
    </Link>
  );
};

ProductImage.propTypes = {
  src: string.isRequired,
  imageDimensions: shape({}).isRequired,
  alt: string,
  to: string,
  orientation: oneOf(['LANDSCAPE', 'PORTRAIT']),
  className: string,
  lazy: bool,
  onImageClick: func,
};

ProductImage.defaultProps = {
  to: null,
  alt: null,
  className: '',
  orientation: 'LANDSCAPE',
  lazy: true,
  onImageClick: undefined,
};

export default ProductImage;
